import { withHttpTransferCacheOptions } from '@angular/platform-browser';

import { DEV_TRANSFER_CACHE_HEADERS } from './dev-surfaces';

export const withAuthenticatedHttpTransferCache = () =>
  withHttpTransferCacheOptions({
    includeRequestsWithAuthHeaders: true,
    includeNonCacheableRequests: true,
    includeHeaders: DEV_TRANSFER_CACHE_HEADERS,
  });
